import React, { useCallback, useEffect, useReducer, useState } from "react"
import {
    obterParametrosIntegracao,
    atualizarParametrosIntegracao,
} from "../../../services/configuracaoDeliveryFornecedor"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { ParametrosIntegracaoInicial } from "../models/parametrosIntegracaoModel"
import { ParametrosIntegracaoActionsTypes } from "./parametrosIntegracaoActions"
import { ParametrosIntegracaoContext } from "./ParametrosIntegracaoContext"
import { parametrosIntegracaoReducer } from "./parametrosIntegracaoReducer"

export function ParametrosIntegracaoContextProvider({ children }: { children: React.ReactNode }) {
    const [parametros, dispatch] = useReducer(parametrosIntegracaoReducer, ParametrosIntegracaoInicial)
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const carregar = async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await obterParametrosIntegracao(autorizacao)
            if ("retornoErro" in response) {
                setErroCarregamento(response.mensagem || "Erro ao carregar integrações")
            } else {
                setErroCarregamento(null)
                dispatch({
                    type: ParametrosIntegracaoActionsTypes.CARREGAR,
                    payload: { ...ParametrosIntegracaoInicial, ...response },
                })
            }
        } catch {
            setErroCarregamento("Erro ao carregar integrações")
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        carregar()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const salvar = useCallback(async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await atualizarParametrosIntegracao(autorizacao, parametros)
            if ("retornoErro" in response) {
                throw new Error(response.mensagem)
            }
            dispatch({
                type: ParametrosIntegracaoActionsTypes.CARREGAR,
                payload: { ...ParametrosIntegracaoInicial, ...response },
            })
        } finally {
            setLoading(false)
        }
    }, [parametros, setLoading])

    return (
        <ParametrosIntegracaoContext.Provider value={{ parametros, dispatch, salvar, erroCarregamento }}>
            <Loading />
            {children}
        </ParametrosIntegracaoContext.Provider>
    )
}
